import { booleanAttribute, ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { SiFormItemComponent } from '@siemens/element-ng/form';
import { ApplicationUser } from '@tran-monorepo/interfaces';
import { ApplicationRequestersComponent } from '../../applications';
import { PeopleSelectComponent } from '../../form';

@Component({
    selector: 'tran-application-detail-people',
    imports: [ApplicationRequestersComponent, SiFormItemComponent, PeopleSelectComponent, TranslatePipe],
    templateUrl: './application-detail-people.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplicationDetailPeopleComponent {
    public readonly people = input<ApplicationUser | ApplicationUser[]>();
    public readonly label = input<string>();
    public readonly control = input<FormControl<ApplicationUser | ApplicationUser[] | null>>();
    public readonly readonly = input(true, { transform: booleanAttribute });
    public readonly multi = input(false, { transform: booleanAttribute });

    protected readonly peopleList = computed<ApplicationUser[]>(() => {
        const value = this.people();
        if (!value) return [];
        return Array.isArray(value) ? value : [value];
    });
}
